import React, { useRef, useEffect } from 'react';
import './FadeInElement.css';

function FadeInElement({ children, side }) {
  const elementRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    });

    observer.observe(elementRef.current);
    // Chequear esto. Sino queda apuntando a null cuando clickeas algún link y no llega a desobservar
    const element = elementRef.current;
    return () => {
      observer.unobserve(element);
    };
  }, []);

  return (
      <div ref={elementRef} className={`fade-in ${side}`}>
        {children}
      </div>
    );
};
    
export default FadeInElement;